module.exports = __webpack_public_path__ + "static/img/qwhouseLogo.b1034243.png";